export function formatCurrency(number) {
    if (!number)
        return null;
    return number.toLocaleString("de", {
        style: "currency",
        currency: "EUR",
        currencyDisplay: "symbol",
        minimumFractionDigits: 0,
    });
}
export function maxTwoDecimals(number) {
    if (!number)
        return null;
    return Math.round((number + Number.EPSILON) * 100) / 100;
}
export function formatLocaleNumber(number) {
    if (!number)
        return null;
    return number.toLocaleString("de", { useGrouping: false });
}
